// @ts-nocheck
import fallbackImage from "@assets/images/fallback-image.svg";
import React from "react";
import {useNavigate} from "react-router-dom";
import {GameCarouselRow} from "@/components";
import {useGetHotGames} from "@/hooks/gamesList/useGetHotGames";
import {useAuthStore} from "@/store/useAuth.store";
import {
  gameCardCls,
  gameCardImageCls,
  gameCardLoadingCls,
  gameCardNameCls,
  gameCardOverlayCls,
  gameCardPlayBtnCls,
  gameCardTagBaseCls,
} from "../_gameCardShared";

const fireTagCls = `${gameCardTagBaseCls} text-(length:--font-h2) leading-none`;

export const TopPayingGames = () => {
  const {games, isPending} = useGetHotGames();
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);

  const handleGameClick = React.useCallback(
    (provider, gameId) => {
      if (authStatus === "authenticated") {
        navigate(`/games/${provider}/${gameId}`);
      } else {
        handleShowAuthModal();
      }
    },
    [authStatus, navigate, handleShowAuthModal]
  );

  const renderCard = (game, idx) => (
    <div
      key={game?.uniqueId || game?.game_id || idx}
      className={gameCardCls}
      onClick={() => handleGameClick(game.provider, game.game_id)}
    >
      <img
        src={game.icon || fallbackImage}
        alt={game.name || game.game_name || ""}
        onError={e => {
          e.target.onerror = null;
          e.target.src = fallbackImage;
        }}
        className={gameCardImageCls}
      />
      <span className={fireTagCls}>🔥</span>
      <div className={gameCardOverlayCls}>
        <span className={gameCardNameCls}>{game.name || game.game_name}</span>
        <button
          type="button"
          className={gameCardPlayBtnCls}
          onClick={e => {
            e.stopPropagation();
            handleGameClick(game.provider, game.game_id);
          }}
        >
          Jugar Ya
        </button>
      </div>
    </div>
  );

  const displayGames = games.slice(0, 6);

  const cards = isPending
    ? Array.from({length: 6}).map((_, i) => (
        <div
          // biome-ignore lint/suspicious/noArrayIndexKey: static placeholder list
          key={`ph-${i}`}
          className={`${gameCardCls} ${gameCardLoadingCls}`}
        />
      ))
    : displayGames.map((game, i) => renderCard(game, i));

  if (!isPending && games.length === 0) return null;

  return (
    <GameCarouselRow
      id="topPayingGames"
      icon="🔥"
      title="Lo más caliente"
      subtitle="No tienen only fans pero están que arden"
      subtitleIcon="🌡️"
      viewAllPath="/gameslist/all"
    >
      {cards}
    </GameCarouselRow>
  );
};
